import type { ErrorResponseSchema } from '@mntn/result'
import { z } from 'zod'

type ErrorResponse = z.infer<typeof ErrorResponseSchema>

export const FORBIDDEN_RESPONSE: ErrorResponse = {
  message: 'Forbidden',
  customCode: 'REQUEST_FORBIDDEN_ERROR',
}

export const NOT_FOUND_RESPONSE: ErrorResponse = {
  message: 'Not found',
  customCode: 'REQUEST_NOT_FOUND_ERROR',
}

/**
 * Shape returned by the local ts-rest-on-Hono adapter
 * (`apps/select-api/src/lib/ts-rest-hono.ts`) when a request fails
 * pathParams/query/headers/body validation. The adapter returns it as a 400.
 */
export const ValidationErrorResponseSchema = z.object({
  customCode: z.literal('REQUEST_VALIDATION_ERROR'),
  message: z.string(),
  issues: z.array(z.unknown()),
})
